// Accommodation types with their respective multipliers for calculating extended times.
export const accommodationTypes = [
  {
    title: 'Up to Time and One-Half (+50%)',
    multiplier: 1.5,
  },
  {
    title: 'Up to Double Time (+100%)',
    multiplier: 2,
  },
];
